/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InsuredResponseDto
 */
export interface InsuredResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof InsuredResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof InsuredResponseDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof InsuredResponseDto
     */
    insuredId: string;
    /**
     * 
     * @type {string}
     * @memberof InsuredResponseDto
     */
    status: InsuredResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof InsuredResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InsuredResponseDto
     */
    longName?: string;
    /**
     * 
     * @type {string}
     * @memberof InsuredResponseDto
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof InsuredResponseDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof InsuredResponseDto
     */
    postcode?: string;
    /**
     * 
     * @type {string}
     * @memberof InsuredResponseDto
     */
    country: string;
    /**
     * 
     * @type {boolean}
     * @memberof InsuredResponseDto
     */
    sanctionsCompleted: boolean;
    /**
     * 
     * @type {Date}
     * @memberof InsuredResponseDto
     */
    sanctionsCompletedDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof InsuredResponseDto
     */
    state?: string;
}


/**
 * @export
 */
export const InsuredResponseDtoStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
} as const;
export type InsuredResponseDtoStatusEnum = typeof InsuredResponseDtoStatusEnum[keyof typeof InsuredResponseDtoStatusEnum];


/**
 * Check if a given object implements the InsuredResponseDto interface.
 */
export function instanceOfInsuredResponseDto(value: object): value is InsuredResponseDto {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('insuredId' in value) || value['insuredId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('sanctionsCompleted' in value) || value['sanctionsCompleted'] === undefined) return false;
    return true;
}

export function InsuredResponseDtoFromJSON(json: any): InsuredResponseDto {
    return InsuredResponseDtoFromJSONTyped(json, false);
}

export function InsuredResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InsuredResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'insuredId': json['insuredId'],
        'status': json['status'],
        'name': json['name'],
        'longName': json['longName'] == null ? undefined : json['longName'],
        'address': json['address'] == null ? undefined : json['address'],
        'city': json['city'] == null ? undefined : json['city'],
        'postcode': json['postcode'] == null ? undefined : json['postcode'],
        'country': json['country'],
        'sanctionsCompleted': json['sanctionsCompleted'],
        'sanctionsCompletedDate': json['sanctionsCompletedDate'] == null ? undefined : (new Date(json['sanctionsCompletedDate'])),
        'state': json['state'] == null ? undefined : json['state'],
    };
}

export function InsuredResponseDtoToJSON(json: any): InsuredResponseDto {
    return InsuredResponseDtoToJSONTyped(json, false);
}

export function InsuredResponseDtoToJSONTyped(value?: InsuredResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'insuredId': value['insuredId'],
        'status': value['status'],
        'name': value['name'],
        'longName': value['longName'],
        'address': value['address'],
        'city': value['city'],
        'postcode': value['postcode'],
        'country': value['country'],
        'sanctionsCompleted': value['sanctionsCompleted'],
        'sanctionsCompletedDate': value['sanctionsCompletedDate'] == null ? undefined : ((value['sanctionsCompletedDate']).toISOString()),
        'state': value['state'],
    };
}

